import React from "react"
import "./ApprovalResultComponent.css"

const ApprovalResultComponent = ({ status }) => {
  if (status === "REQUEST_APPROVED") {
    return <span className="approved-text">Success</span>
  } else if (status === "REQUEST_DENIED") {
    return <span className="denied-text">Failure</span>
  } else {
    return null
  }
}

export default ApprovalResultComponent
